var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronsLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21917_26605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.15825 9.99984L9.41216 3.46077C9.7686 3.08601 9.75763 2.49281 9.38286 2.13499C9.0081 1.77718 8.41528 1.79046 8.05981 2.1639L1.18481 9.3514C0.838135 9.71519 0.838135 10.2842 1.18481 10.6479L8.05981 17.8354C8.41747 18.2089 9.0106 18.2224 9.3856 17.8647C9.57544 17.6795 9.6731 17.4334 9.6731 17.1873C9.6731 16.9542 9.58642 16.7209 9.4131 16.5393L3.15825 9.99984ZM16.9114 16.5389L10.6575 9.99984L16.9114 3.46077C17.2678 3.08601 17.2568 2.49281 16.8821 2.13499C16.5073 1.77718 15.9141 1.79074 15.5563 2.16429L8.6813 9.35179C8.33462 9.71558 8.33462 10.2846 8.6813 10.6483L15.5563 17.8358C15.914 18.2093 16.5071 18.2228 16.8821 17.8651C17.0754 17.6795 17.1731 17.4334 17.1731 17.1873C17.1731 16.953 17.0872 16.7225 16.9114 16.5389Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21917_26605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 20,
    fill: "white",
    transform: "translate(0.297852)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronsLeft);
export default __webpack_public_path__ + "static/media/chevrons-left.6cb831200ec7d2fbde5505b9ab1b3d6f.svg";
export { ForwardRef as ReactComponent };